import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function DemoIntroDialog({ open, onContinue, createAccountHref, onCreateAccount }) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && typeof onContinue === "function") {
          onContinue();
        }
      }}
    >
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Welcome to the MVP demo</DialogTitle>
          <DialogDescription className="text-sm leading-6">
            This is an early public version of the product.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-3 text-sm text-slate-600">
          <p>• Explore the shared sample project</p>
          <p>• Create one temporary demo project of your own</p>
          <p>• Demo projects are cleared daily</p>
          <p>• Daily AI usage is limited</p>
          <p>Create an account to keep your work and unlock full usage.</p>
        </div>

        <div className="mt-6 flex items-center justify-end gap-3">
          {createAccountHref ? (
            <Button type="button" variant="secondary" onClick={onCreateAccount} className="rounded-xl">
              Create an account
            </Button>
          ) : null}
          <Button type="button" onClick={onContinue} className="rounded-xl">
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
